export enum PointType {
  'CCT' = 'CCT',
  'DIA' = 'DIA',
  'NNI' = 'NNI',
  'OPTICAL' = 'OPTICAL',
  'NONE' = 'NONE',
  'POINT' = 'POINT',
}
